<template>

  <b-modal
    id="prereserver-modal"
    :ok-title="$t('venteLot.Prereserver')"
    :title="$t('venteLot.Prereserver') + ' ' + venteLot.tostring"
    ok-variant="primary"
    :cancel-title="$t('Cancel')"
    cancel-variant="outline-primary"
    @ok="handlePrereserver">

    <div class="row">
      <div class="col-md-12 mb-4">
        {{$t('venteLot.messagePrereserver')}}
      </div>
      <div class="col-md-12">
        <b-form-group
          :label="$t('venteLot.PropositionAcheteur')"
          class="medium-label mb-4"
          label-for="proposition-input">
          <custom-form-file
            id="proposition-input"
            v-model="proposition"
            :browse-text="$t('Select')"
            :placeholder="$t('Select') + ' ' + $t('a') + ' ' + $t('contactDocument.file')"
            :multiple="false"
          />
        </b-form-group>
      </div>
    </div>

  </b-modal>

</template>

<script>

import api from "../../services/api";
import CustomFormFile from "../../components/b122/editFields/CustomFormFile.vue";

export default {

  name: "PrereserverModal",

  components: {CustomFormFile},

  props: {
    venteLot: {
      type: Object,
      default: null
    },
  },

  data() {
    let okTitle = 'venteLot.Prereserver'

    return {
      okTitle: okTitle,
      proposition: null
    }
  },

  emits: ['didPrereserver'],

  async mounted() {
  },

  methods: {

    async handlePrereserver(bvModalEvent) {
      bvModalEvent.preventDefault()
      if (this.proposition) {

        let formData = new FormData()
        formData.append('venteLotId', this.venteLot.id)
        formData.append('proposition', this.proposition)

        await api({
          method: 'POST',
          url: `/venteLot/prereserver`,
          data: formData
        })
          .then(async (response) => {
            if (response.status === 200) {
              this.$emit('didPrereserver')
              this.resetModal()
              this.hideModal()
            }
          })
          .catch((error) => {
            this.errorToast(this.$i18n.t('Error'))
          })

      } else {
        this.errorToast(this.$i18n.t('venteLot.PropositionObligatoire'))
      }
    },

    resetModal() {
      this.proposition = null
    },

    hideModal() {
      this.$bvModal.hide('prereserver-modal')
    },

    errorToast(message) {
      this.$bvToast.toast(message, {
        autoHideDelay: 3000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "danger",
        solid: true,
      })
    }

  }

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/venteLot/PrereserverModal.vue